export function fullDepthLimitations(project) {
  if (
    project.hasGeotextiles
    || project.hasShallowUtilities === 1
    || project.hasTreatedBase === 1
    || project.pavementType === 2
    || project.pavementType === 3
  ) {
    return {
      title: "Limitations",
      isDisqualifying: true,
      message:
        "You have indicated the presence of geosynthetic materials, shallow utilities less than 1 ft from the surface, saturated subgrade or base layers (concrete pavement or treated base). These circumstances create potential subsurface conflicts and consequently, FDR is not a recommended treatment option for your segment."
    };
  }
}
